var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slash-commands-menu',{attrs:{"commands":_vm.commands,"value":_vm.value,"input-selector":_vm.inputSelector},on:{"select":_vm.onSelect}},[(_vm.glSlots().default)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }